import type { ComponentProps } from 'react';
import React, { useMemo } from 'react';

import { cn } from '@change/ds-utils';

import { useI18n } from '@change-corgi/core-react/i18n';

type Props = {
	amount: number;
	amountLocalized: string;
	isSelected: boolean;
	onClick: (value: { amount: number; amountLocalized: string }) => void;
};

export const AmountButton: React.FC<Props & Omit<ComponentProps<'button'>, 'onClick'>> = ({
	amount,
	amountLocalized,
	isSelected,
	onClick,
	className,
	...rest
}) => {
	const { translate } = useI18n();

	const value = useMemo(() => {
		return amount ? amountLocalized : translate('corgi.membership.awareness.other_amount_label');
	}, [amount, amountLocalized, translate]);
	return (
		<button
			type="button"
			data-testid="membership-awareness-form-amount-button"
			onClick={() => onClick({ amount, amountLocalized })}
			data-selected={isSelected}
			// when selected the border grows 1px->2px and horizontal padding shrinks 16px->15px to keep the box size
			className={cn(
				'm-0 h-12 max-w-full cursor-pointer rounded-lg border border-solid border-[#707070] bg-transparent px-4 py-0 text-sm font-bold',
				'data-[selected=true]:border-stroke-accent-primary-strong data-[selected=true]:bg-fill-accent-primary-weaker data-[selected=true]:border-2 data-[selected=true]:px-[15px]',
				className,
			)}
			{...rest}
		>
			{value}
		</button>
	);
};
